import * as React from "react";
import "./SendQuoteModal.scss";
import { Modal } from "antd";
import { IQuote } from 'src/services/interfaces/trade/precificacao/IQuote';
import { Link } from 'react-router-dom';
import { contato } from 'src/util/constants';

interface ISendQuoteModal {
  quote: IQuote;
  onClose: () => void;
  visible: boolean;
}

export const SendQuoteModal: React.FC<ISendQuoteModal> = ({ quote, visible, onClose }) => {

  return (
    <Modal title="Cotação em negociação" className="modal-view-teds modal-small" okText="Fechar" cancelButtonProps={{ hidden: true }} visible={visible} onOk={onClose} onCancel={onClose}>
      Sua cotação já foi enviada para nossa equipe. Você pode entrar em contato conosco informando o número da cotação {quote?.id} através do Whastapp {contato.whatsappFormatado} ou
      <Link
        target="_blank"
        to={{ pathname: `https://api.whatsapp.com/send?phone=55${contato.whastapp}&text=Gostaria%20de%20proceder%20com%20a%20negocia%C3%A7%C3%A3o%20da%20cota%C3%A7%C3%A3o%20${quote?.id}` }}> clicando aqui
      </Link>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/Modais/SendQuoteModal/SendQuoteModal.tsx